import React from 'react'
import { ViewerContext } from './ViewerContext.jsx'
import * as R from 'ramda'
class ViewerProvider extends React.Component {
  updateToggle = show => {
    let scrollTopBuffer = setTimeout(() => {}, 1)
    const newState = {
      toggledSetting: show,
    }
    const highlightToSet = this.state.highlightedSection
    clearTimeout(scrollTopBuffer)

    if (show === 'none') {
      this.highlightSection('')
    } else if (show === 'both') {
      if (this.state.panesFlipped) {
        this.setState({
          leftFlyoutContent: 'translation',
          rightFlyoutContent: 'transcription',
        })
      } else {
        this.setState({
          leftFlyoutContent: 'transcription',
          rightFlyoutContent: 'translation',
        })
      }
    }
    if (show !== 'none') {
      setTimeout(() => {
        const button = document.querySelectorAll('.js-flyout__menu button')[0]
        if (button) {
          button.focus()
        }
      }, 300)
    }
    if (highlightToSet) {
      scrollTopBuffer = setTimeout(() => {
        this.setScroll(highlightToSet)
      }, 300)
    }
    this.setState(newState)
    this.setMinZoom(show)
  }

  concatArrays = (leftArr, rightArr) => {
    return leftArr.concat(rightArr)
  }
  reverseContent = () => {
    const currentLeft = this.state.leftFlyoutContent
    const currentRight = this.state.rightFlyoutContent

    const panesFlipped = this.state.panesFlipped
    this.setState({
      leftFlyoutContent: currentRight,
      rightFlyoutContent: currentLeft,
      panesFlipped: !panesFlipped,
    })
  }
  updateSidebar = (flyout, tab) => {
    const currentSide = flyout + 'FlyoutContent'
    this.setState({
      [currentSide]: tab,
    })
  }

  setScroll = targetClass => {
    const scrollTarget = document.querySelector(
      `.flyout-page .js-${targetClass}`
    )
    const scrollPosition = scrollTarget.getBoundingClientRect().top
    let currentScroll = scrollTarget.closest('.flyout__scroll').scrollTop

    scrollTarget.closest('.flyout__scroll').scrollTop =
      currentScroll + scrollPosition - 200 // 200 to clear masthead
  }

  highlightSection = section => {
    let scrollTopBuffer = setTimeout(() => {}, 1)
    const highlightToSet =
      this.state.highlightedSection === section || section === ''
        ? null
        : section
    this.setState({
      highlightedSection: highlightToSet,
    })
    const newObj = this.state.currentSections.find(x => x.id === highlightToSet)
    const currentOverlay = newObj ? newObj : null
    this.generateOverlay(currentOverlay)
    clearTimeout(scrollTopBuffer)
    if (highlightToSet) {
      scrollTopBuffer = setTimeout(() => {
        this.setScroll(highlightToSet)
      }, 300)
      const currentSectionObj = this.state.currentSections.find(
        x => x.id === section
      )
      if (R.propEq('type', 'colorNotes', currentSectionObj)) {
        this.showAllFootnotes(currentSectionObj.parentSection)
      }
    }
    if (section) {
      if ((this.state.toggledSetting === 'none') & (highlightToSet !== '')) {
        this.updateToggle('one')
      }
    }
  }

  storeViewer = viewer => {
    const newViewer = this.state.viewer === viewer ? null : viewer
    if (newViewer) {
      this.setState({
        viewer: newViewer,
      })
    }
  }

  findCoordinate = (overlayArr, viewerPosition) => {
    let newObj = null
    for (let i = 0; i < overlayArr.length; i++) {
      const rect = this.state.viewer.viewport.imageToViewportRectangle(
        overlayArr[i].x,
        overlayArr[i].y,
        overlayArr[i].width,
        overlayArr[i].height
      )
      const x = rect.x
      const x2 = rect.x + rect.width
      const y = rect.y
      const y2 = rect.y + rect.height
      if (
        x < viewerPosition.x &&
        viewerPosition.x < x2 &&
        y < viewerPosition.y &&
        viewerPosition.y < y2
      ) {
        return (newObj = overlayArr[i])
      }
    }
    return newObj
  }
  generateOverlay = currentOverlay => {
    const overlayDiv = document.getElementsByClassName('viewer-overlay')[0]
    this.state.viewer.removeOverlay(overlayDiv.id)
    if (currentOverlay) {
      overlayDiv.id = currentOverlay.id
      overlayDiv.style.display = 'block' // removeOverlay lets us update the position of the rectangle but it also adds display: none;
      this.state.viewer.addOverlay({
        element: overlayDiv,
        location: this.state.viewer.viewport.imageToViewportRectangle(
          currentOverlay.x,
          currentOverlay.y,
          currentOverlay.width,
          currentOverlay.height
        ),
      })
    }
  }
  handleOverlayClick = e => {
    if (e.quick === true) {
      const viewerPosition = this.state.viewer.viewport.pointFromPixel(
        e.position
      )
      const overlayArr = this.state.currentSections
      const currentOverlay = this.findCoordinate(overlayArr, viewerPosition)
      const viewer = this.state.viewer
      if (currentOverlay) {
        // viewer.zoomPerClick = 1
        this.highlightSection(currentOverlay.id)
      } else {
        this.setZoomLevelState(viewer.viewport.getZoom(true))
      }
      this.setState({ viewer })
    }
  }
  setZoomLevelState = zoom => {
    const viewer = this.state.viewer
    // viewer.zoomPerClick = 2

    if (this.state.zoomLevel !== zoom) {
      this.setState({
        zoomLevel: zoom,
      })
    }
  }

  updateZoomLevel = zoom => {
    this.state.viewer.viewport.zoomTo(zoom)
  }

  getSections = arr => {
    this.setState({ currentSections: arr })
  }

  updateFootnote = (e, sectionId, num, currentView) => {
    e.preventDefault()
    e.stopPropagation()
    const currentFootnotes = this.state.currentFootnotes
    const anchor = document.querySelector(`#${currentView}-${sectionId}-${num}`)
    const key = currentView + '-' + sectionId
    const anchorPosition = anchor.getBoundingClientRect().y

    if (!currentFootnotes[key]) {
      currentFootnotes[key] = num
      e.target.setAttribute('aria-pressed', true)
    } else if (currentFootnotes[key] !== num) {
      currentFootnotes[key] = num
      e.target.setAttribute('aria-pressed', true)
    } else {
      delete currentFootnotes[key]
      e.target.setAttribute('aria-pressed', false)
    }

    document.querySelector('.js-flyout__scroll').scrollTop =
      anchorPosition + 196

    if (!anchor.closest('.flyout-section').classList.contains('visible')) {
      this.toggleDrawer(e)
    }

    this.setState({ currentFootnotes })

    setTimeout(() => {
      const currentSection = anchor.closest('.js-flyout-section')
      const filter = R.filter(
        x => x.classList.contains('js-drawer'),
        currentSection.children
      )
      filter[0].focus()
    }, 350)

    return
  }

  toggleDrawer = (e, sectionId, currentView) => {
    e.preventDefault()
    const button = e.currentTarget
    const section = button.closest('.js-flyout-section')
    if (section.classList.contains('visible')) {
      section.classList.remove('visible')
      button.setAttribute('aria-expanded', false)
      // check for colornotes selection
      if (
        this.state.highlightedSection &&
        this.state.highlightedSection !== sectionId
      ) {
        this.highlightSection('')
      }
      //reset focused
      if (sectionId && currentView) {
        this.showAllFootnotes(sectionId, currentView)
      }
      // check for other visible drawers before setting state
      const hasDrawers = document.querySelector('.visible')
      if (!hasDrawers) {
        this.setState({ drawerToggled: false })
      }
    } else {
      section.classList.add('visible')
      const scrollPosition = section.getBoundingClientRect().top
      let currentScroll = section.closest('.flyout__scroll').scrollTop

      section.closest('.flyout__scroll').scrollTop =
        currentScroll + scrollPosition - 200 // 200 to clear masthead

      button.setAttribute('aria-expanded', true)
      this.setState({ drawerToggled: true })
    }
  }
  showAllFootnotes = (sectionId, currentView) => {
    const currentFootnotes = this.state.currentFootnotes
    if (currentView) {
      const key = currentView + '-' + sectionId
      delete currentFootnotes[key]
    } else {
      if (currentFootnotes['transcription-' + sectionId]) {
        delete currentFootnotes['transcription-' + sectionId]
        const transcriptSelector = document.querySelector(
          `.js-flyout__content--transcription .js-${sectionId} .current`
        )
        transcriptSelector.setAttribute('aria-pressed', false)
      }
      if (currentFootnotes['translation-' + sectionId]) {
        delete currentFootnotes['translation-' + sectionId]
        const translatorSelector = document.querySelectorAll(
          `.js-flyout__content--translation .js-${sectionId} .current`
        )
        translatorSelector.setAttribute('aria-pressed', false)
      }
    }
    this.setState({ currentFootnotes })
  }

  updatePaginatorPosition = currentPosition => {
    this.setState({
      paginatorPosition: currentPosition,
    })
  }

  setMinZoom = toggledSetting => {
    const windowHeight = window.innerHeight
    const windowWidth = window.innerWidth
    if (windowWidth / windowHeight < 1.6) {
      let zoomLevel
      if (toggledSetting === 'both') {
        zoomLevel = 1
      } else if (toggledSetting === 'one') {
        zoomLevel = 0.8
      } else {
        zoomLevel = 0.6
      }
      this.updateZoomLevel(zoomLevel)
      this.setState({ zoomLevel: zoomLevel, defaultZoom: zoomLevel })
    } else {
      return
    }
  }

  setPaginatorState = state => {
    this.setState({ paginatorOpen: state })
  }

  state = {
    highlightedSection: null,
    leftFlyoutContent: 'transcription',
    rightFlyoutContent: 'translation',
    toggledSetting: 'none', //both, one,
    viewer: null,
    currentSections: [],
    zoomLevel: 0.6,
    maxZoom: 4,
    minZoom: 0.6,
    currentFootnotes: {},
    drawerToggled: false,
    paginatorPosition: 0,
    paginatorOpen: 'closed', //half, closed, full
    paginatorHeight: 0,
  }

  render() {
    const { children } = this.props
    return (
      <ViewerContext.Provider
        value={{
          state: this.state,
          setZoomLevelState: this.setZoomLevelState,
          getSections: this.getSections,
          reverseContent: this.reverseContent,
          handleOverlayClick: this.handleOverlayClick,
          updateToggle: this.updateToggle,
          updateSidebar: this.updateSidebar,
          highlightSection: this.highlightSection,
          storeViewer: this.storeViewer,
          viewerTotalPages: 34,
          catalogTotalPages: 21,
          updateFootnote: this.updateFootnote,
          toggleDrawer: this.toggleDrawer,
          showAllFootnotes: this.showAllFootnotes,
          updateZoomLevel: this.updateZoomLevel,
          updatePaginatorPosition: this.updatePaginatorPosition,
          setPaginatorState: this.setPaginatorState,
        }}
      >
        {children}
      </ViewerContext.Provider>
    )
  }
}
export default ViewerProvider
